import { useLocation } from 'react-router-dom';
import type * as api from '../../../../api';
// eslint-disable-next-line max-len
import { type StandardApplicationPublicAccessEntrypointContextDataFragment } from '../../../../api/fragments/StandardApplicationPublicAccessEntrypointContextData';
import { useMultipleDealerIds } from '../../../../components/contexts/DealerContextManager';
import ComparisonCalculatorStage from '../../StandardApplicationEntrypoint/ComparisonPage/ComparisonCalculatorStage';

type ComparisonLocationState = {
    vehicleIds: string[];
};

export type ComparisonPageProps = {
    endpoint: StandardApplicationPublicAccessEntrypointContextDataFragment;
};

const ComparisonPage = ({ endpoint }: ComparisonPageProps) => {
    const state = useLocation().state as api.Maybe<ComparisonLocationState>;
    const { dealerIds } = useMultipleDealerIds();

    return <ComparisonCalculatorStage dealerIds={dealerIds} endpoint={endpoint} vehicleIds={state?.vehicleIds || []} />;
};

export default ComparisonPage;
